/**
 * Format file size in bytes to human readable format
 * @param bytes - File size in bytes
 * @returns Formatted file size string
 */
function formatFileSize(bytes: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
}

/**
 * Download a Blob response from fetch
 * @param response Fetch Response object
 * @param defaultName Default filename if response header doesn't provide one
 */
async function downloadBlob(blob: Blob, fileName?: string) {
  function getFileExtension(mime: string) {
    switch (mime) {
      case 'application/pdf': return 'pdf';
      case 'text/csv': return 'csv';
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return 'xlsx';
      default: return 'bin';
    }
  }

  const extension = getFileExtension(blob.type);
  const now = new Date();
  const timeStamp = now.toISOString().replace(/[:.]/g, '-').slice(0, 19);
  const filename = `${fileName ?? timeStamp}.${extension}`;
  console.log('filename', filename);
  // Create temporary link
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();

  // Cleanup
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

async function downloadBase64(base64: string, mimeType: string, fileName?: string) {
  const blob = base64ToBlob(base64, mimeType);
  await downloadBlob(blob, fileName);
}

function base64ToBlob(base64: string, mimeType = "application/octet-stream") {
  const byteChars = atob(base64);
  const byteArray = Uint8Array.from(byteChars, c => c.charCodeAt(0));
  return new Blob([byteArray], { type: mimeType });
}

// Namespace export for convenient usage: fileUtil.formatFileSize()
export const fileUtil = {
  formatFileSize,
  downloadBlob,
  downloadBase64,
  base64ToBlob,
} as const;

